import PropTypes from "prop-types";

export default PropTypes.shape({
  action: PropTypes.string,
  actionAt: PropTypes.string,
  added: PropTypes.string.isRequired,
  agent: PropTypes.string.isRequired,
  candidate: PropTypes.string.isRequired,
  column: PropTypes.string.isRequired,
  duplicateLink: PropTypes.string,
  id: PropTypes.number.isRequired,
  link: PropTypes.string.isRequired,
  status: PropTypes.string,
  unread: PropTypes.bool.isRequired,
  unreadLink: PropTypes.string,
});
